module.exports = __webpack_public_path__ + "static/img/background_sebastian_final_1920x1200_cat920x600_opacity85.43c3da1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background_sebastian_final_1920x1200_cat920x600_opacity85.jpg
// module id = z7lL
// module chunks = 0